import React, { useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import event from "../../assets/image/evnet/event.png";
import shine from "../../assets/image/evnet/Shines.svg";
import camera from "../../assets/image/evnet/Camera.svg";
import arrowleft from "../../assets/icons/Arrow/left.svg";
import { HeaderIconL } from "../../assets/components/HeaderGroup";
import { addAppMessageListener, postToApp } from "../../bridges/appBridge";

const EventMarketing = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;
    const storeBusinessNumber = data.store_business_number;

    const fileInputRef = useRef(null);

    const ua =
        typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    const isAndroid = useMemo(() => /Android/i.test(ua), [ua]);
    const isRN = typeof window !== "undefined" && !!window.ReactNativeWebView;
    const isAndroidRN = isAndroid && isRN;
    const isIOSRN = isRN && !isAndroidRN;

    // iOS RN & 웹: 파일 선택 후 Step1로 이동
    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            navigate("/event/marketing/gallery", {
                state: {
                    ...data,
                    imageFile: file,
                    imageDataUrl: reader.result,
                },
            });
        };
        reader.readAsDataURL(file);
    };

    const handleManual = () => {
        if (!isRN) {
            navigate("/event/marketing/gallery", { state: data });
            return;
        }

        if (isIOSRN) {
            if (fileInputRef.current) {
                const input = fileInputRef.current;
                input.value = "";
                setTimeout(() => {
                    // 컴포넌트 살아있고 여전히 iOSRN인 경우에만 실행
                    if (input) input.click();
                }, 250); // 200~300ms 정도가 적당
            }
            return;
        }

        // 🔹 레거시 방식 대비: 기존 RN이 window.receiveCameraImage(dataUrl)를 호출하는 경우
        if (isAndroidRN) {
            const originalReceive = window.receiveCameraImage;
            window.receiveCameraImage = function (dataUri) {
                window.receiveCameraImage = originalReceive || null;

                if (!dataUri) {
                    alert("이미지 결과가 비어 있습니다.");
                    return;
                }

                try {
                    // base64 → File 변환
                    const [h, b] = dataUri.split(",");
                    const mime = h.match(/:(.*?);/)?.[1] || "image/jpeg";
                    const bin = atob(b);
                    const u8 = new Uint8Array(bin.length);
                    for (let i = 0; i < bin.length; i++)
                        u8[i] = bin.charCodeAt(i);

                    const file = new File(
                        [new Blob([u8], { type: mime })],
                        "picked.jpg",
                        { type: mime }
                    );

                    navigate("/event/marketing/gallery", {
                        state: {
                            ...data,
                            imageFile: file,
                            imageDataUrl: dataUri,
                        },
                    });
                } catch (e) {
                    alert("이미지 처리에 실패했습니다.");
                }
            };

            const off = addAppMessageListener((msg) => {
                const t = msg?.type;
                const p = msg?.payload || {};

                if (t === "PICK_IMAGE_RESULT") {
                    off?.();
                    window.receiveCameraImage = originalReceive || null;

                    // base64 dataUrl 결과
                    const dataUrl =
                        p?.dataUrl ||
                        (Array.isArray(p?.dataUrls) && p.dataUrls.length > 0
                            ? p.dataUrls[0]
                            : null);

                    if (dataUrl) {
                        try {
                            const dataUrl = p.dataUrl;
                            const [h, b] = dataUrl.split(",");
                            const mime =
                                h.match(/:(.*?);/)?.[1] || "image/jpeg";
                            const bin = atob(b);
                            const u8 = new Uint8Array(bin.length);
                            for (let i = 0; i < bin.length; i++)
                                u8[i] = bin.charCodeAt(i);

                            const file = new File(
                                [new Blob([u8], { type: mime })],
                                "picked.jpg",
                                { type: mime }
                            );

                            navigate("/event/marketing/gallery", {
                                state: {
                                    ...data,
                                    imageFile: file,
                                    imageDataUrl: dataUrl,
                                },
                            });
                        } catch (e) {
                            alert("이미지 처리에 실패했습니다.");
                        }
                        return;
                    }

                    // uri만 주는 경우 – 이 경우는 뒤에서 uri 기반 처리하기로
                    if (p?.uri) {
                        navigate("/event/marketing/gallery", {
                            state: {
                                ...data,
                                imageUri: p.uri,
                            },
                        });
                        return;
                    }

                }

                if (t === "PICK_IMAGE_CANCEL" || t === "PICK_IMAGE_ERROR") {
                    off?.();
                    alert(p?.message || "이미지 선택 중 오류가 발생했습니다.");
                }
            });

            setTimeout(() => {
                try {
                    postToApp({
                        type: "OPEN_IMAGE_PICKER",
                        payload: { at: Date.now(), reason: "menu_manual" },
                    });
                } catch (_) { }
                try {
                    window.Android?.openGallery?.();
                } catch (_) { }
            }, 300);

            return;
        }
    };
    const redirectGallery = () => {
        handleManual();
        // navigate(`/event/marketing/gallery`, { state: data });
    };

    const redirectAI = () => {
        navigate(`/event/marketing/ai`, { state: { data } });
    };

    const onHome = () => {
        navigate("/ads/main", { state: { storeBusinessNumber } });
    };

    return (
        <div className="min-h-screen">
            <HeaderIconL
                title="이벤트 만들기"
                icon={arrowleft}
                onIconClick={onHome}
            />

            <div className="pt-[40px] items-center flex flex-col">
                <img src={event} alt="이벤트" className="pb-[20px] h-[180px]" />
                <div className="pt-[8px] text-center">
                    <p className="text-b1 text-text-subtler">
                        홍보용, 포스팅용
                    </p>
                    <p className="text-t2 text-text-default">
                        <span className="text-text-primary">
                            가게 홍보 이벤트
                        </span>
                        를 만들어 보세요
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-2 pt-[40px] justify-center gap-[12px] px-[12px]">
                <button
                    className="bg-surface-light-subtle rounded-[16px] px-[12px] flex flex-col items-center"
                    onClick={redirectGallery}
                >
                    <img src={camera} alt="캘린더" className="pt-[16px]" />
                    <div className="py-[16px] text-center text-t4 text-text-subtle">
                        내 사진 사용하기
                    </div>
                </button>
                <button
                    className="bg-surface-light-subtle rounded-[16px] px-[12px] flex flex-col items-center"
                    onClick={redirectAI}
                >
                    <img src={shine} alt="shine" className="pt-[16px]" />
                    <div className="py-[16px] text-center text-t4 text-text-subtle">
                        AI로 만들기
                    </div>
                </button>

                <div className="pt-[32px] text-c2 text-text-subtler text-center">
                    <span className="text-c1">내가 가지고 있는 사진</span>
                    <br />
                    또는
                    <br />
                    <span className="text-c1">지금 촬영한 사진</span>으로
                    <br />
                    홍보용 이미지 만들기
                </div>
                <div className="pt-[32px] text-c2 text-text-subtler text-center">
                    <span className="text-c1">AI 자동 추천</span>
                    <br />
                    또는
                    <br />
                    <span className="text-c1">내가 선택한 옵션</span>으로
                    <br />
                    홍보용 이미지 만들기
                </div>
            </div>

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
            />
        </div>
    );
};

export default EventMarketing;
